import ISqlReport from "../models/ISqlReport";
import { fetchSecureData } from "../utils";

export const getRoleReports = async (accessToken: string, roleId: number) => {
  try {
    const data = await fetchSecureData(
      "GET",
      `/api/SqlReport/GetSqlReportsForRoleId?roleId=${roleId}`,
      accessToken
    );
    const roleReports = ((await data.json()) as any).value as ISqlReport[];
    if (roleReports !== undefined) {
      return roleReports;
    } else {
      return [] as ISqlReport[];
    }
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(
      `Fetch error for /api/SqlReport/GetSqlReportsForRoleId?roleId=${roleId}`,
      err
    );
  }
  return [] as ISqlReport[];
};

export default getRoleReports;
